import axios from 'axios';

let prefix = "/endless"

const EndlessLevelApi = {
	listEndlessLevel(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getEndlessLevelInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	archiveEndlessLevel(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createEndlessLevel(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateEndlessLevel(payload) {
		return axios.post(prefix + "/update", payload)
	},
	selectEndlessCreepWaveGroup(payload) {
		return axios.post(prefix + "/select-creep-wave-group", payload)
	},
}

export default EndlessLevelApi;